import React from "react";
import ReactDOM from "react-dom/client";
import "survey-core/defaultV2.min.css";
import "./styles/index.css";
import reportWebVitals from "./reportWebVitals";
import AppRouter from "./routes/AppRouter";
import { Layout } from "./components/Layout/Layout";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { surveyLocalization } from "survey-core";
import "survey-core/i18n/spanish";

// Establece el español como idioma por defecto
surveyLocalization.defaultLocale = "es";

const theme = createTheme({
  palette: {
    primary: {
      main: "#ffee00", // Amarillo normal
      light: "#FAF36E", // Amarillo claro
    },
    secondary: { main: "#737300" },
    tertiary: {
      main: "#003C75",
    },
  },
  components: {
    MuiToggleButtonGroup: {
      defaultProps: {
        color: "primary",
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          textTransform: "none",
          fontSize: "0.875rem",
          padding: "4px 10px",
          borderColor: theme.palette.divider,
          "&.Mui-selected": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.getContrastText(theme.palette.primary.main),
          },
          "&.Mui-selected:hover": {
            backgroundColor: theme.palette.primary.light || theme.palette.primary.main,
          },
        }),
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: "#FAEF5C",
          color: "#000",
          "&:hover": {
            backgroundColor: "#FAF36E",
          },
        },
        outlined: {
          borderColor: "black",
          color: "#333",
          "&:hover": {
            borderColor: "#999",
            backgroundColor: "#f5f5f5",
          },
        },
      },
    },
    // Overrides para inputs
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#474747", // Color al hacer focus
            borderWidth: 2,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          "&.Mui-focused": {
            color: "#474747", //Color del label al hacer focus
          },
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
const basename = process.env.PUBLIC_URL || "/";

root.render(
  <ThemeProvider theme={theme}>
    <BrowserRouter basename={basename}>
      <Layout>
        <AppRouter />
      </Layout>
    </BrowserRouter>
  </ThemeProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
